<script>
  import { Icon, ArrowsPointingIn, ArrowsPointingOut, Trash, Cog } from "svelte-hero-icons";
  import { tooltip } from "$utils/tooltip";
  import Checkbox from "$lib/Inputs/CheckboxInput.svelte";

  export let onExpandAll;
  export let onCollapseAll;
  export let onClearLogs;
  export let persistLogs;
  export let eventFilterMode;

  const FILTER_OPTIONS = [
    { value: "logs_only", label: "Logs" },
    { value: "important", label: "Events" },
    { value: "all", label: "All" },
  ];

  let showDropdown = false;

  function toggleDropdown() {
    showDropdown = !showDropdown;
  }

  function handlePersistLogsChange(event) {
    persistLogs = event.detail;
  }

  function setFilterMode(mode) {
    eventFilterMode.set(mode);
  }
</script>

<div class="flex space-x-1 bg-surface-muted p-1 rounded-md justify-between mb-2">
  <div class="flex space-x-1 items-center">
    <div class="flex rounded-md bg-surface-muted p-0.5">
      {#each FILTER_OPTIONS as option}
        <button
          on:click={() => setFilterMode(option.value)}
          class="px-2 py-0.5 text-xs font-medium rounded transition-colors {$eventFilterMode ===
          option.value
            ? 'bg-surface text-content shadow-sm'
            : 'text-content-subtle hover:text-content'}"
        >
          {option.label}
        </button>
      {/each}
    </div>
    <div class="w-px bg-surface-hover mx-1 h-4"></div>
    <button
      use:tooltip
      aria-label="Expand All"
      on:click={onExpandAll}
      class="p-1 hover:bg-surface-hover rounded"
    >
      <Icon src={ArrowsPointingOut} class="w-4 h-4" />
    </button>
    <button
      use:tooltip
      aria-label="Collapse All"
      on:click={onCollapseAll}
      class="p-1 hover:bg-surface-hover rounded"
    >
      <Icon src={ArrowsPointingIn} class="w-4 h-4" />
    </button>
    <div class="w-px bg-surface-hover mx-1 h-4"></div>
    <button
      on:click={onClearLogs}
      class="text-xs text-red-500 hover:text-red-700 font-semibold py-1 px-2 rounded flex items-center"
    >
      <Icon src={Trash} class="w-3 h-3 mr-1" />
      Clear
    </button>
  </div>
  <button
    on:click={toggleDropdown}
    class="p-1 hover:bg-surface-hover rounded"
    aria-label="Settings"
    use:tooltip
  >
    <Icon src={Cog} class="w-4 h-4" />
  </button>
</div>

{#if showDropdown}
  <div class="mb-4 p-3 bg-surface border border-line-strong rounded-md shadow-lg text-xs">
    <Checkbox bind:value={persistLogs} label="Persist Logs" on:input={handlePersistLogsChange} />
  </div>
{/if}
